import { AppTextField } from 'components';
import usePlans from 'hooks/API/GET/usePlans';

function PlanRatesSpecifier({ handleChanges, planRates }) {
  const { data, isError } = usePlans({
    enabled: true,
    configs: {
      params: { mode: 'dropdown' },
    },
  });
  const plans = data?.data || {};
  if (isError) return null;

  return (
    <>
      {plans?.map?.((plan) => {
        return (
          <div key={plan._id} className="w-25 p-3 ">
            <AppTextField
              labelProps={{
                label: `Plan price`,
                htmlFor: `${plan._id}`,
              }}
              inputProps={{
                placeholder: `Plan price`,
                id: `${plan.name}-${plan._id}`,
                name: `${plan._id}`,
                value: planRates.find((x) => plan._id === x.planId)?.price || '',
                onChange: (event) => {
                  const price = event.target.value;
                  handleChanges({ price, planId: plan._id }, plan, event);
                },
              }}
              // fieldErrors={errors['name']}
            />
            <small className="__appColor">
              Provide <strong>{plan.name}</strong> price
            </small>
          </div>
        );
      })}
    </>
  );
}

PlanRatesSpecifier.defaultProps = {
  planRates: [],
  handleChanges: () => {},
};

export default PlanRatesSpecifier;
